module.exports = __webpack_public_path__ + "static/media/founder.1f227262.jpg";